import type { SwiftIdApplicationStatus } from './swift-id-application-status.model';

export function transformSwiftIdApplicationStatus(
  applicationStatus: SwiftIdApplicationStatus,
): SwiftIdApplicationStatus {
  return {
    ...applicationStatus,
    createdAt: applicationStatus.createdAt * 1000,
    updatedAt: applicationStatus.updatedAt * 1000,
  };
}
